module.exports = __webpack_public_path__ + "img/review.4419ce7.png";